var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import SwipeableNewsList from 'app/components/topNewsModule/subNews/SwipeableNewsList';
import React from 'react';
import { NewsPerView } from 'app/components/topNewsModule/models/NewsPerView';
import styled from 'styled-components';
import { SIZES, Typography } from '@fupa/fupa-uikit';
import { SkeletonPlaceholderDataContainer, SkeletonPlaceholderOverlay, SkeletonPlaceholderWrapper } from 'app/styles/districtModules/SkeletonPlaceholderStyles';
import { DistrictMainPageModuleType, useDistrictMainPageTracking } from 'app/components/district/news/DistrictMainPageTracking';
import { useMediaQuery } from '@mui/material';
import { streamModuleViewsBreakpoint } from 'app/styles/media';
import SwipeableNewsListSkeleton from 'app/components/topNewsModule/subNews/SwipeableNewsListSkeleton';
const DataContainer = styled(SkeletonPlaceholderDataContainer).withConfig({
  componentId: "sc-by7b5x-0"
})(["padding:", ";text-align:center;", ";", ";"], SIZES['16'], props => props.theme.streamLayoutOneColBig(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: ", ";\n  "])), SIZES['36']), props => props.theme.desktopLayout(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: ", ";\n  "])), SIZES['56']));
const StyledTypography = styled(Typography).withConfig({
  componentId: "sc-by7b5x-1"
})(["", ";", ";"], props => props.theme.streamLayoutOneColBig(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    font-size: ", ";\n  "])), SIZES['16']), props => props.theme.desktopLayout(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    font-size: ", ";\n  "])), SIZES['16']));
export default function ResponsiveSwipeableNewsList(_ref) {
  let {
    newsList
  } = _ref;
  const {
    updateTrackingData
  } = useDistrictMainPageTracking();
  const isMobile = useMediaQuery("(max-width: ".concat(streamModuleViewsBreakpoint, "px)"));
  return newsList.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SwipeableNewsList, {
    newsList: newsList,
    newsPerView: isMobile ? NewsPerView.Small : NewsPerView.Large,
    updateTrackingData: data => updateTrackingData(DistrictMainPageModuleType.TOPNEWS, data),
    "data-sentry-element": "SwipeableNewsList",
    "data-sentry-source-file": "ResponsiveSwipeableNewsList.tsx"
  })) : /*#__PURE__*/React.createElement(SkeletonPlaceholderWrapper, {
    "data-sentry-element": "SkeletonPlaceholderWrapper",
    "data-sentry-component": "ResponsiveSwipeableNewsList",
    "data-sentry-source-file": "ResponsiveSwipeableNewsList.tsx"
  }, /*#__PURE__*/React.createElement(SkeletonPlaceholderOverlay, {
    "data-sentry-element": "SkeletonPlaceholderOverlay",
    "data-sentry-source-file": "ResponsiveSwipeableNewsList.tsx"
  }, /*#__PURE__*/React.createElement(DataContainer, {
    "data-sentry-element": "DataContainer",
    "data-sentry-source-file": "ResponsiveSwipeableNewsList.tsx"
  }, /*#__PURE__*/React.createElement(StyledTypography, {
    variant: "body2",
    "data-sentry-element": "StyledTypography",
    "data-sentry-source-file": "ResponsiveSwipeableNewsList.tsx"
  }, "Es liegen keine weiteren Meldungen in den letzten 7 Tagen vor."))), /*#__PURE__*/React.createElement(SwipeableNewsListSkeleton, {
    numChildren: NewsPerView.Large,
    animation: false,
    "data-sentry-element": "SwipeableNewsListSkeleton",
    "data-sentry-source-file": "ResponsiveSwipeableNewsList.tsx"
  }));
}